module.exports = __webpack_public_path__ + "media/4x3/gb-ba1c7f5d.svg";